export GenericService from "./generic.service";



// WEBPACK FOOTER //
// ./src/core/data/service/index.js